export const SIZES = {
  medium: 'medium',
  large: 'large',
};
